import { render, staticRenderFns } from "./inedx.vue?vue&type=template&id=251b67e3&"
import script from "./inedx.vue?vue&type=script&lang=js&"
export * from "./inedx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports